import { isNotEmpty } from '@doltech/utils/lib/text';
import { types as t } from 'mobx-state-tree';

import { AbstractQuestionWithBlankCorrectAnswers } from '../../../question-data-model/Question/abstract-question-with-blank-correct-answers.store';
import { BlankUserAnswerInstance } from '../../../question-data-model/Question/Blank/blank-user-answer.store';
import { TestQuestionStore } from '../test-question.store';

export interface AnswerQuestionInput {
  text: string;
  blankId: string;
}

export const AbstractDoTestQuestionWithBlanks = t
  .compose(TestQuestionStore, AbstractQuestionWithBlankCorrectAnswers)
  .named('AbstractDoTestQuestionWithBlanks')
  .actions((self) => ({
    onAnswerQuestion(input: AnswerQuestionInput) {
      const { blankId, text } = input;
      const existedUserAnswer = self.userAnswers.find(
        (userAnswer) => userAnswer.blankId === blankId
      );
      if (existedUserAnswer) {
        existedUserAnswer.userAnswer = text;
      } else {
        self.userAnswers.push({
          blankId,
          userAnswer: text,
        });
      }
    },
    clearUserAnswerByBlankId(blankId: string) {
      const index = self.userAnswers.findIndex((anw) => anw.blankId === blankId);
      if (index > -1) {
        self.userAnswers[index] = { blankId, userAnswer: '' };
      }
    },
  }))
  .views((self) => ({
    isAnswered(answer: BlankUserAnswerInstance) {
      return answer && isNotEmpty(answer.userAnswer);
    },
    getUserAnswers() {
      return self.userAnswers.map(({ blankId, userAnswer }) => ({
        blankId,
        text: userAnswer,
      }));
    },
  }));
